import { parse, differenceCiede2000, type Color } from "culori";
import type { TokenGroup } from "../api/types/token.js";
import { flattenTokensByType } from "./tokens.js";

export function parseColor(value: string): Color | null {
  const parsed = parse(value);
  return parsed ?? null;
}

/** CIEDE2000 perceptual distance. 0 = identical, higher = more different. */
export function colorDistance(color1: string, color2: string): number | null {
  const c1 = parse(color1);
  const c2 = parse(color2);
  if (!c1 || !c2) return null;

  const diff = differenceCiede2000();
  return diff(c1, c2);
}

export interface ColorTokenMatch {
  name: string;
  value: string;
  distance: number;
}

/**
 * Find the closest color token within a CIEDE2000 threshold.
 * Default threshold is 10 (perceptually similar).
 */
export function findClosestColorToken(
  color: string,
  tokens: TokenGroup,
  threshold: number = 10,
): ColorTokenMatch | null {
  const parsedColor = parse(color);
  if (!parsedColor) return null;

  const colorTokens = flattenTokensByType(tokens, "color");
  const diff = differenceCiede2000();

  let closest: ColorTokenMatch | null = null;

  for (const [name, tokenValue] of colorTokens) {
    const tokenColor = parse(tokenValue);
    if (!tokenColor) continue;

    const distance = diff(parsedColor, tokenColor);

    if (distance <= threshold) {
      if (!closest || distance < closest.distance) {
        closest = { name, value: tokenValue, distance };
      }
    }
  }

  return closest;
}
